import { UserDetails } from "domain/user";

interface PendoOptions {
    visitor: { id: string; email: string; fullName?: string };
    account: { id: string; accountName: string };
}

declare global {
    interface Window {
        pendo?: { initialize: (options: PendoOptions) => void };
    }
}

export const initializePendo = (user: UserDetails) => {
    if (!window.pendo) {
        return;
    }
    window.pendo.initialize({
        visitor: { id: user.uuid, email: user.email, fullName: user.name },
        account: { id: user.tenantUuid, accountName: user.tenantName },
    });
};
